import {Component, EventEmitter, inject, Inject, Input, OnInit, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommunicationCenterService} from "@modules/communication-center";
import {EventService} from "shared/event.service";
export interface ButtonListDialogData {
    title: string
    list: {
        id: string | number, label: string, value: string, disabled?: boolean, isEnabledForFreemium?: boolean, isFree?: boolean
    }[],
    isFreemiumPremiumFeatureEnabled?: boolean,
}

@Component({
    selector: 'app-button-list-dialog',
    templateUrl: './button-list-dialog.component.html',
    styleUrls: ['./button-list-dialog.component.scss'],
    standalone: false
})
export class ButtonListDialogComponent implements OnInit {
    communicationCenter = inject(CommunicationCenterService);
    private eventService = inject(EventService);
    @Input() noModalContext?: boolean;
    @Input() inputData?: ButtonListDialogData;
    @Output() outputEvent?: EventEmitter<{
        label: string, value: string
    }>;
    constructor(
        public ref: MatDialogRef<ButtonListDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ButtonListDialogData) {
    }

    ngOnInit(): void {
        this.manageDialogPanelClass();
    }

    private manageDialogPanelClass(): void {
        this.ref.addPanelClass('button-list-dialog-panel');
        if (this.freemiumPremiumFeatureEnabled) {
            this.ref.addPanelClass('button-list-dialog-panel--freemium-premium-enabled');
        }
    }

    public selectedItem(item: { label: string, value: string, disabled?: boolean, isEnabledForFreemium?: boolean, isFree?: boolean }): void {
        if (!item.isEnabledForFreemium && this.freemiumPremiumFeatureEnabled) {
            this.openFreemiumPremiumModal();
            return;
        }
        if (this.noModalContext) {
            this.outputEvent.next(item)
        } else {
            this.ref.close(item.value);
        }
    }

    public close(): void {
        this.ref.close();
    }

    public get dataInjected(): ButtonListDialogData {
        return this.inputData ? this.inputData : this.data;
    }

    public isBtnDisabled(btn: {
        label: string, value: string, disabled?: boolean, isEnabledForFreemium?: boolean, isFree?: boolean
    }): boolean {
        return btn.disabled;
    }

    get freemiumPremiumFeatureEnabled(): boolean {
        return !!this.data?.isFreemiumPremiumFeatureEnabled;
    }

    public openFreemiumPremiumModal() {
        this.eventService.trackEvent('open modal', 'button list', 'premium');
        this.communicationCenter
            .getRoom('freemium-premium')
            .getSubject('access-premium-display-compare-modal')
            .next(true);
    }
}